module.exports = "https://static.wmbcdn.com/uniweb/images/cf1d692beed4f78e44ebc7c1e5fa4735.webp";